module.exports = __webpack_public_path__ + "img/button-software.2a233dbf.svg";